import { AxiosResponse } from "axios";
import { apiClient } from "@/repositories/clients";
import { User, UserProjectGroup } from "@/types/User";

const loadAppUser = (): Promise<User> =>
  apiClient.get<void, AxiosResponse<User>>(`/user/app`).then((response) => response.data);

const loadHubSpotToken = (): Promise<string> =>
  apiClient
    .get<void, AxiosResponse<{ token: string }>>(`/user/hubspot/identification`)
    .then((response) => response.data.token);

const loadUsersForProject = (customerName: string, siteId: string): Promise<User[]> =>
  apiClient
    .get<void, AxiosResponse<User[]>>(`/user/project/${customerName}/${siteId}`)
    .then((response) => response.data);

const loadAllUsersForProject = (customerName: string, siteId: string): Promise<User[]> =>
  apiClient
    .get<void, AxiosResponse<User[]>>(`/user/project/${customerName}/${siteId}/all`)
    .then((response) => response.data);

const setUserProjectPermissionByEmail = (
  email: string,
  customerName: string,
  siteId: string,
  groups: UserProjectGroup[],
): Promise<{ userFound: boolean }> =>
  apiClient
    .post<void, AxiosResponse<User>>(
      `/user/by-email/${email}/${customerName}/${siteId}/project-permission`,
      {
        groups,
      },
    )
    .then(() => ({ userFound: true }))
    .catch((error) => {
      if (error?.response?.status === 404) {
        return { userFound: false };
      }
      throw error;
    });

const inviteUser = (
  customerName: string,
  siteId: string,
  email: string,
  firstName: string,
  lastName: string,
  company: string,
): Promise<User> =>
  apiClient
    .post<void, AxiosResponse<User>>(`/user/invite/${customerName}/${siteId}/app`, {
      email: email,
      first_name: firstName,
      last_name: lastName,
      company: company,
    })
    .then((response) => response.data);

const deleteUser = (username: string): Promise<void> =>
  apiClient
    .delete<void, AxiosResponse<void>>(`/user/${username}`)
    .then((response) => response.data);

export default {
  loadAppUser,
  loadHubSpotToken,
  loadUsersForProject,
  loadAllUsersForProject,
  setUserProjectPermissionByEmail,
  inviteUser,
  deleteUser,
};
